import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ActivationPage from "./pages/ActivationPage";
import WelcomePage from "./pages/WelcomePage";
import MainMenuPage from "./pages/MainMenuPage";
import PlayerPage from "./pages/PlayerPage";
import SettingsPage from "./pages/SettingsPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";
import TickerBar from "./components/TickerBar";
import BootstrapGate from "./components/BootstrapGate";
import InstallPrompt from "./components/InstallPrompt";
import { I18nProvider } from "./i18n";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./styles/themes.css";
import SplashScreen from "./components/SplashScreen";
import PlayersLanding from "./pages/PlayersLanding";
import { brand } from "./brand.config";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [splashDone, setSplashDone] = useState(false);

  // Apply brand font across entire app
  useEffect(() => {
    if (brand.fontFamily) {
      document.body.style.fontFamily = brand.fontFamily;
    }
  }, []);

  return (
    <I18nProvider>
      <ThemeProvider>
        {brand.showSplash && !splashDone && (
          <SplashScreen onDone={() => setSplashDone(true)} />
        )}
        <div className="App min-h-screen bg-[#050507]">
          <BrowserRouter basename={process.env.REACT_APP_BASENAME || ""}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/activate" element={<ActivationPage />} />
              <Route path="/welcome" element={<WelcomePage />} />
              <Route path="/menu" element={<MainMenuPage />} />
              <Route path="/player" element={<PlayerPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/players" element={<PlayersLanding />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <TickerBar deviceKey={typeof window !== "undefined" ? (localStorage.getItem("device_key") || "") : ""} apiBase={API} />
            <BootstrapGate />
            <InstallPrompt />
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" />
        </div>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
